import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    howTo: {
      content: [
        'A team of lawyers is available over the phone to answer any legal questions related to your activity. They can be contacted Monday to Saturday between 9am and 6pm.',
        'Just call the freephone number below:',
      ],
      phoneNumber: '+33\xa04\xa011\xa062\xa000\xa075',
      title: 'How does it work?',
    },
    include: {
      items: [
        'A team of lawyers is available over the phone to answer any legal questions related to your activity. They can be contacted Monday to Saturday between 9am and 6pm.',
      ],
      title: 'This coverage includes',
    },
    similarOffersTitle: 'Other insurances related to your coverage',
    title: 'Legal assistance',
  },
  fr: {
    howTo: {
      content: [
        'Une équipe de juriste répond par téléphone à toutes vos questions légales liées à votre activité. Vous pouvez les contacter du lundi au samedi entre 9h et 18h.',
        "Il suffit d'appeler le numéro gratuit ci-dessous\xa0:",
      ],
      phoneNumber: '+33\xa04\xa011\xa062\xa000\xa075',
      title: 'Comment ca marche\xa0?',
    },
    include: {
      items: [
        'Une équipe de juristes répond par téléphone à toutes vos questions légales liées à votre activité. Vous pouvez les contacter du lundi au samedi entre 9h et 18h.',
      ],
      title: 'Cette garantie inclut',
    },
    similarOffersTitle: 'Autres assurances liées à votre couverture',
    title: 'Assistance juridique',
  },
} as const);

export default locales;
